import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contrat-item',
  templateUrl: './contrat-item.component.html',
  styleUrls: ['./contrat-item.component.scss']
})
export class ContratItemComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
